export interface History {
    messages: Message[];
}

export interface Message {
    role: "user" | "assistant";
    content: Content;
}

export interface Content {
    text: string;
    dashboard?: Layout;
}

export type Layout = Widget[];

export interface Widget {
    widget: string;
    weight: number;
}

export class Client {
    url: string;

    constructor(url: string) {
        this.url = url;
    }

    async ask(history: History): Promise<Content> {
        const res = await fetch(this.url, {
            method: "POST",
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(history)
        });
        if (res.status == 200) {
            return await res.json();
        } else {
            let text = await res.text();
            throw new Error(`Status ${res.status}:\n${text}`);
        }
    }
}
